import { render, staticRenderFns } from "./WidgetReturnZip.vue?vue&type=template&id=d6f2a1bc&scoped=true"
import script from "./WidgetReturnZip.vue?vue&type=script&lang=ts"
export * from "./WidgetReturnZip.vue?vue&type=script&lang=ts"
import style0 from "./WidgetReturnZip.vue?vue&type=style&index=0&id=d6f2a1bc&prod&scoped=true&lang=css"
import style1 from "./WidgetReturnZip.vue?vue&type=style&index=1&id=d6f2a1bc&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "d6f2a1bc",
  null
  
)

export default component.exports